import React, { useState, useEffect } from "react";
import {
  Layout,
  Row,
  Col,
  Card,
  Button,
  Input,
  Dropdown,
  Table,
  Modal,
  Form,
  message,
} from "antd";
import { UnorderedListOutlined, CreditCardOutlined } from "@ant-design/icons";
import DefaultLayout from "../../components/layout/DefaultLayout";
import payment from "../../services/payment";

const TransactionsPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const fetchTransactions = async () => {
    setLoading(true);
    try {
      const data = await payment.getTransactionsWithOrders(); // call API
      console.log(data);
      setTransactions(data.transactions || []);
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch transactions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  // Parent table (Transactions)
  const columns = [
    { title: "Payment ID", dataIndex: "square_payment_id", key: "square_payment_id" },
    { title: "Amount", dataIndex: "amount", key: "amount" },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => {
        if (!date) return "-";
        const d = new Date(date);
        return `${d.getDate().toString().padStart(2, "0")}-${(
          d.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${d.getFullYear()} ${d
          .getHours()
          .toString()
          .padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}`;
      },
    },
  ];

  // Child table (Orders inside each Transaction)
  const orderColumns = [
    { title: "Order ID", dataIndex: "id", key: "id" },
    { title: "Customer", dataIndex: "customer_name", key: "customer_name" },
    { title: "WhatsApp", dataIndex: "whatsapp", key: "whatsapp" },
    { title: "Address", dataIndex: "address", key: "address" },
    { title: "Miles", dataIndex: "miles", key: "miles" },
    { title: "Subtotal", dataIndex: "subtotal", key: "subtotal" },
  ];

  // Search filter (by customer/whatsapp/address)
  const filteredTransactions = transactions.filter((txn) =>
    txn.orders?.some((order) => {
      const q = searchQuery.toLowerCase();
      return (
        order.customer_name?.toLowerCase().includes(q) ||
        order.whatsapp?.toLowerCase().includes(q) ||
        order.address?.toLowerCase().includes(q)
      );
    })
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <DefaultLayout>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Card
              style={{ display: "flex", justifyContent: "space-between" }}
              bodyStyle={{ padding: "12px 24px" }}
            >
              <span>
                <CreditCardOutlined /> Transactions
              </span>
            </Card>
          </Col>
        </Row>

        <Card style={{ marginTop: 16 }}>
          <Input
            size="large"
            placeholder="Search by Customer / WhatsApp / Address"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </Card>

        <Card style={{ marginTop: 16 }}>
          <Table
            columns={columns}
            dataSource={filteredTransactions.map((txn) => ({
                ...txn,
                key: txn.square_payment_id, // ✅ important
              }))}
            expandable={{
              expandedRowRender: (record) => (
                <Table
                  columns={orderColumns}
                  dataSource={record.orders.map((o) => ({ ...o, key: o.id }))}
                  pagination={false}
                  size="small"
                />
              ),
            }}
            loading={loading}
            pagination={{ pageSize: 10 }}
          />
        </Card>
      </DefaultLayout>
    </Layout>
  );
};

export default TransactionsPage;
